import Template from "backbone/projects/templates/registration_topics.js.hamlc"
import ProjectsCollection from "backbone/projects/collections/projects_collection.js"
import ProjectsViewState from "backbone/projects/models/projects_view_state.js"
import ProjectsView from "backbone/projects/views/projects_view.js"

export default class RegistrationTopicsView extends Backbone.View
  events:
    "click .js-add-topics"       : "addTopics"
    "click .js-next-page"        : "nextPage"

  initialize: (options) ->
    @completeUrl = options.completeUrl
    @finishLaterUrl = options.finishLaterUrl
    @finishLater = false
    @render()
    @listenTo(@collection, "change", @checkStatus)

  render: ->
    @$el.html(Template(addProjectsUrl: @options.addProjectsUrl))

    @collection = new ProjectsCollection
    @viewState = new ProjectsViewState
      addTopicsMode: true
    @projectsView = new ProjectsView(
      el: @$el.find("#projects")
      topics: @options.topics
      collection: @collection
      viewState: @viewState
    )
    @collectionView = @projectsView.collectionView

  saveAndFinishLater: ->
    @finishLater = true
    @collectionView.saveAndFinishLater()

  addTopics: ->
    if @collectionView.allTopicInputsValid()
      @collectionView.saveProjectTopics()

  checkStatus: ->
    if @finishLater
      finished = @collection.noSavePending()
      nextLocation = @finishLaterUrl
    else
      finished = @collection.saveTopicsComplete()
      nextLocation = @completeUrl

    if finished
      contently.flash.notice("All topics have been added to your projects")
      window.location = nextLocation
    else
      @showNextPageLink()

  showNextPageLink: ->
    @$el.find(".js-next-page").css("display", "inline-flex")

  nextPage: ->
    window.location = @completeUrl



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/views/registration_topics_view.js.coffee